import React from 'react';
import { useNavigate } from 'react-router-dom';

export const BackButton = ({ to, className = '' }) => {
  const navigate = useNavigate();
  return (
    <button
      className={`back-btn${className ? ' ' + className : ''}`}
      onClick={() => (to ? navigate(to) : navigate(-1))}
      type="button"
    >
      ← Back
    </button>
  );
};
